<template>
  <div class="c-app">
    <TheSidebar />
    <CWrapper :class="{ 'content-toggle': isHamburger }">
      <TheHeader />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid class="pl-0 pr-0">
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter />
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  },

  computed: {
    isHamburger() {
      return (
        this.$store &&
        this.$store.state &&
        this.$store.state.user &&
        this.$store.state.user.isHamburger
      );
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
